/**
 *
 * EventTime
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { format } from 'utils/date-fns/index.js';

const Wrapper = styled.div`
  font-size: 12px;
  line-height: 1.2;
`;

function EventTime(props) {
  const { start, end, compact, className } = props;
  const tpl = compact ? 'mm' : 'p';
  return (
    <Wrapper className={`d-flex flex-column ${className}`}>
      <span>{format(start, tpl)}</span>
      <span>{format(end, tpl)}</span>
    </Wrapper>
  );
}

EventTime.propTypes = {
  start: PropTypes.object,
  end: PropTypes.object,
  compact: PropTypes.bool,
  className: PropTypes.string,
};

export default EventTime;
